import axios from 'axios';
import { useDialog } from 'muibox';
import { useContext, useState } from 'react';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';

export type CognitoEmailLookupResult = {
    username: string;
    email: string | null;
};

const useCognitoEmailLookup = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const [lookupCognitoEmailLoading, setLookupCognitoEmailLoading] = useState<boolean>(false);

    const lookupCognitoEmail = async (subscriberId: string): Promise<CognitoEmailLookupResult | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !userContext.user.username) {
            return null;
        }

        const query = `${settingsContext.routes.subscribers.base}${subscriberId}/cognito-email`;

        setLookupCognitoEmailLoading(true);

        return axios
            .get<CognitoEmailLookupResult>(query, {
                headers: {
                    Authorization: userContext.jwtToken,
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => {
                setLookupCognitoEmailLoading(false);

                return response.data;
            })
            .catch(error => {
                console.error('lookupCognitoEmail', error);
                setLookupCognitoEmailLoading(false);
                handleHttpError(error, dialog);

                return null;
            });
    };

    return { lookupCognitoEmail, lookupCognitoEmailLoading };
};

export default useCognitoEmailLookup;
